import {
  Component,
  ElementRef,
  EventEmitter,
  inject,
  Input,
  OnChanges,
  Output,
  signal,
  SimpleChanges,
  ViewChild,
} from '@angular/core';
import { FormsModule } from '@angular/forms';
import { DatePipe, NgClass, NgTemplateOutlet } from '@angular/common';
import { MessageService } from '../services/message.service';
import { NumberService } from '../services/number.service';

@Component({
  selector: 'app-chat-modal',
  standalone: true,
  imports: [FormsModule, DatePipe, NgClass, NgTemplateOutlet],
  templateUrl: 'chat-modal.component.html',
})
export class ChatModalComponent implements OnChanges {
  @Input({ required: true }) numberId!: number;
  @Input({ required: true }) providerCodeId!: number;
  @Input() phoneNumber = '';
  @Input() historyOnly = false;
  @Output() closeModal = new EventEmitter<void>();
  @Output() pinged = new EventEmitter<string>();

  @ViewChild('messageInput') messageInput?: ElementRef<HTMLTextAreaElement>;

  private messageService = inject(MessageService);
  private numberService = inject(NumberService);

  messages = signal<any[]>([]);
  sentMessages = signal<any[]>([]);
  showHistory = signal(false);
  messageText = signal('');

  ngOnChanges(changes: SimpleChanges) {
    if (changes['numberId'] || changes['providerCodeId']) {
      this.showHistory.set(this.historyOnly);
      this.sentMessages.set([]);
      this.messageText.set('');
      this.loadMessages();
    }
  }

  loadMessages() {
    this.messageService.getUserMessages(this.numberId, this.providerCodeId).subscribe({
      next: (data) => this.messages.set(data.messages),
      error: (err) => console.error(err),
    });
  }

  lastClientMessage() {
    const clientMessages = this.messages().filter((message) => !message.mine);
    return clientMessages.length ? clientMessages[clientMessages.length - 1] : null;
  }

  showFullHistory() {
    this.showHistory.set(true);
  }

  sendMessage() {
    const message = this.messageText().trim();
    if (!message) {
      return;
    }
    this.messageService.sendMessage(this.numberId, this.providerCodeId, message).subscribe({
      next: (data) => {
        this.messages.update((messages) => [...messages, data.message]);
        this.sentMessages.update((messages) => [...messages, data.message]);
        this.messageText.set('');
        this.messageInput?.nativeElement.focus();
        this.numberService.pingNumber(this.numberId, this.providerCodeId).subscribe({
          next: (data) => this.pinged.emit(data.pinged_at),
          error: (err) => console.error(err),
        });
      },
      error: (err) => console.error(err),
    });
  }

  onClose() {
    this.closeModal.emit();
  }
}
